import Big from 'big.js';

const FinantialAccountTransaction = class {
    constructor(object) {
        if (object === undefined) {
            this.id = null;
            this.creator = null;
            this.reference = null;
            this.amount = new Big(0);
            this.tip = new Big(0);
            this.accountBalance = new Big(0);
            this.createdAt = null;
            this.proof = null;
            this.paymentMethod = null;
            this.saleId = null;
            this.purchaseId = null;
        } else {
            this.id = object.id;
            this.creator = object.creator;
            this.reference = object.reference;
            this.amount = (object.amount !== undefined) ? new Big(object.amount) : new Big(0);
            this.tip = (object.tip !== undefined && object.tip !== null) ? new Big(object.tip) : new Big(0);
            this.accountBalance = (object.accountBalance !== undefined) ? new Big(object.accountBalance) : new Big(0);
            this.createdAt = (object.createdAt !== undefined) ? new Date(object.createdAt) : null;
            this.proof = object.proof || null;
            this.paymentMethod = object.paymentMethod || null;
            this.saleId = (object.sale !== undefined && object.sale !== null) ? object.sale.id : null;
            this.purchaseId = (object.purchase !== undefined && object.purchase !== null) ? object.purchase.id : null;
        }
    }

    // Dinero que realmente movió la cuenta: amount (venta/compra) + tip
    // (propina). El balance del backend se mueve con esta suma, así que la
    // columna "Monto" del detalle debe mostrar este valor — mostrar solo
    // `amount` hacía parecer que la propina no entró a la cuenta.
    get totalMoved() {
        return this.amount.plus(this.tip);
    }
};

export default FinantialAccountTransaction;
